import { LandingPageAgentChat } from '../AgentChat/LandingPageAgentChat';
import { useEditor } from './EditorContext';

export const EditorSidebar = () => {
  const {
    sidebarCollapsed,
    sendMessageToIframe,
    isVisualEditMode,
    toggleVisualEditMode,
    ...editorData
  } = useEditor();

  return (
    <div
      className={`flex flex-col bg-white transition-all duration-300 ease-in-out ${
        sidebarCollapsed
          ? 'w-0 -translate-x-full overflow-hidden opacity-0'
          : 'w-96 translate-x-0 opacity-100'
      }`}
    >
      {!sidebarCollapsed && (
        <LandingPageAgentChat
          agentName="landingPageAgent"
          changes={editorData.agentChanges}
          onChangeClick={editorData.agentChangeClick}
          onAcceptChange={editorData.agentAcceptChange}
          onDiscardChange={editorData.agentDiscardChange}
          onAcceptAllChanges={editorData.agentAcceptAllChanges}
          onDiscardAllChanges={editorData.agentDiscardAllChanges}
          sendMessageToIframe={sendMessageToIframe}
          isVisualEditMode={isVisualEditMode}
          onToggleVisualEdit={toggleVisualEditMode}
        />
      )}
    </div>
  );
};
